import React, { FC, Fragment, ReactNode } from 'react';

import { FaqCategory } from '../faqData';
import styles from './FaqList.module.scss';

type Props = {
  categories: Array<FaqCategory>;
  search?: string;
};

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const highlight = (text: string, search: string): ReactNode => {
  const query = search.trim();
  if (!query) {
    return text;
  }

  const parts = text.split(new RegExp(`(${escapeRegExp(query)})`, 'gi'));

  return parts.map((part, index) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <mark className={styles.mark} key={index}>
        {part}
      </mark>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    )
  );
};

const FaqList: FC<Props> = ({ categories, search = '' }) => (
  <div className={styles.list}>
    {categories.map((category) => (
      <section className={styles.section} id={category.id} key={category.id}>
        <header className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>{category.heading}</h2>
          <span className={styles.sectionCount}>{category.questions.length}</span>
        </header>
        <div className={styles.items}>
          {category.questions.map((question) => (
            <article className={styles.item} key={question.title}>
              <h3 className={styles.question}>{highlight(question.title, search)}</h3>
              <div
                className={styles.answer}
                dangerouslySetInnerHTML={{ __html: question.content }}
              />
            </article>
          ))}
        </div>
      </section>
    ))}
  </div>
);

export default FaqList;
